import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteSuperUserRole } from "../../../redux/actions/superUserAction";
import DeleteModal from "../../../components/modals/deleteModal";
import DeletedPopUp from "../../../components/popups/DeletedPopUp";
import ErrorPopup from "../../../components/popups/ErrorPopup";

const SuperUserRoleTableData = ({ data, index, fetchSuperList, currentPage }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteShow, setDeleteShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deletedPop, setDeletedPop] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  const delFunc = () => {
    dispatch(deleteSuperUserRole(deleteId, onDelSuccess, onDeleteError));
  };

  const onDelSuccess = (data) => {
    setDeleteShow(false);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      fetchSuperList();
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDeleteError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.role_id ? data?.role_id : '--'}</td>
      <td className="table-each-row-data">{data?.role_name ? data?.role_name : '--'}</td>
      <td className="table-each-row-data">{data?.role_level ? data?.role_level : '--'}</td>

      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/super-user/role/view/${data?.id}`)}
          >
            {"view"}
          </button>
          <span className="vr vr_line mt-1"></span>
          <button
            className="button-edit1"
            type="button"
            onClick={() => navigate(`/super-user/role/edit/${data.id}`)}
          >
            {"edit"}
          </button>
          <span className="vr vr_line mt-1"></span>
          <button
            className="button-disable"
            type="button"
            color={"green"}
            onClick={() => {
              setDeleteId(data?.id);
              setDeleteShow(true);
            }}
          >
            Delete
          </button>
        </div>
      </td>
      <DeleteModal
        delFunc={delFunc}
        title={`This Super User - ${data?.role_id} ?`}
        show={deleteShow}
        handleClose={() => setDeleteShow(false)}
      />
      <DeletedPopUp
        title={`This Super User - ${data?.role_id} `}
        show={deletedPop}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </tr>
  );
};

export default SuperUserRoleTableData;